const Glosspt = () => {
    
    
    return ( 
      <div id="glosspt">
        <p>  </p>
        <h1 className="glosstitle">Glossário</h1>
        <p>  </p>
        <div className="glosscontent">
            <p> 
                <span style={{fontWeight: 'bold'}} > Etapa. </span> 
                <span style={{color: 'green'}}> Percurso iniciado por uma validação. </span>
            </p>
            <p> 
                <span style={{fontWeight: 'bold'}} > Viagem. </span> 
                <span style={{color: 'green'}}> Sequência de etapas iniciadas por validações separadas da seguinte por menos de 70 minutos (excepto a última). </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Troço. </span> 
            <span style={{color: 'green'}}> Parte da rede entre duas estações consecutivas. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Passageiro Troço (Pax Troço). </span> 
            <span style={{color: 'green'}}> Unidade de medida da procura: quando um passageiro viaja no metro entre duas estações consecutivas, a procura aumenta um passageiro troço. Quando num veículo viajam dez passageiros entre duas estações consecutivas, a procura aumenta dez passageiros troço. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Passageiro Quilómetro (Pax Km). </span> 
            <span style={{color: 'green'}}> Unidade de medida da procura: quando um passageiro viaja no metro entre duas estações distantes um quilómetro, a procura aumenta um passageiro quilómetro. Quando num veículo viajam dez passageiros entre duas estações distantes 500 metros, a procura aumenta cinco passageiros quilómetro. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Veículo Quilómetro (VKm). </span> 
            <span style={{color: 'green'}}> Unidade de medida da produção / oferta: quando um veículo circula em serviço comercial entre duas estações distantes um quilómetro, a oferta aumenta um veículo quilómetro. Quando uma composição com dois veículos circula em serviço comercial entre duas estações distantes um quilómetro, a oferta aumenta dois veículos quilómetro. </span>
            </p>
            <p> 
            <span style={{fontWeight: 'bold'}} > Lugar Quilómetro (LKm). </span> 
            <span style={{color: 'green'}}> Unidade de medida da produção/oferta: quando um veículo Eurotram, cuja capacidade é de 216 passageiros, circula em serviço comercial entre duas estações distantes um quilómetro, a oferta aumenta 216 lugares quilómetro. Se fôr um veículo Tram-Train, aumenta 248 lugares quilómetro. Quando uma composição com dois veículos Eurotram circula em serviço comercial entre duas estações distantes um quilómetro, a oferta aumenta 432 lugares quilómetro. </span>
            </p> 
            <p> 
            <span style={{fontWeight: 'bold'}} > Taxa de Ocupação (TO). </span> 
            <span style={{color: 'green'}}> Quociente entre passageiros quilómetro e lugares quilómetro referentes ao mesmo espaço e tempo. Percentagem média de lugares oferecidos nesse espaço e tempo que são ocupados. </span>
            </p> 
        </div>
      </div>
    );
}

export default Glosspt;